import { Controller } from "@hotwired/stimulus"
import { marked } from "marked"

export default class extends Controller {
  static targets = ["write", "preview", "textarea", "writeTab", "previewTab"]

  connect() {
    // Start in Write mode
    this.showWrite()
  }

  showWrite() {
    this.writeTarget.classList.remove("hidden")
    this.previewTarget.classList.add("hidden")

    this.writeTabTarget.classList.add("border-b-2", "border-gray-900", "text-gray-900")
    this.writeTabTarget.classList.remove("text-gray-500")
    this.previewTabTarget.classList.remove("border-b-2", "border-gray-900", "text-gray-900")
    this.previewTabTarget.classList.add("text-gray-500")
  }

  showPreview() {
    this.writeTarget.classList.add("hidden")
    this.previewTarget.classList.remove("hidden")

    this.previewTabTarget.classList.add("border-b-2", "border-gray-900", "text-gray-900")
    this.previewTabTarget.classList.remove("text-gray-500")
    this.writeTabTarget.classList.remove("border-b-2", "border-gray-900", "text-gray-900")
    this.writeTabTarget.classList.add("text-gray-500")

    this.updatePreview()
  }

  updatePreview() {
    const content = this.textareaTarget.value
    this.previewTarget.innerHTML = marked.parse(content || "")
  }
}
